import { Package } from 'lucide-react';
import { EmptyState } from '~/components/ui/EmptyState';
import { calculateOrderTotal } from '~/utils';
import { OrderCard } from '~/pages/orders/sections/OrderCard.tsx';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import type { RootState } from '~/redux/store.ts';
import { SellerOrderCard } from '~/pages/orders/sections/SellerOrderCard.tsx';

type OrderListOrder = {
  id: string;
  status: string;
  createdAt: string;
  buyingOrganization: {
    name: string;
  };
  sellingOrganization: {
    name: string;
  };
  items: Array<{
    quantity: { value: number };
    price: number;
  }>;
};

type OrderlistProps = {
  orders: OrderListOrder[];
  noOrderMessage: string;
  noOrderTitle: string;
};

export function OrderList({
  orders,
  noOrderMessage,
  noOrderTitle,
}: Readonly<OrderlistProps>) {
  const navigate = useNavigate();
  const role = useSelector((state: RootState) => state.auth.user?.role);

  if (orders.length === 0)
    return (
      <EmptyState
        icon={<Package size={48} />}
        title={noOrderTitle}
        message={noOrderMessage}
      />
    );

  return (
    <div className="space-y-4 mt-8">
      {orders.map((order) => {
        if (role === 'BUYER') {
          return (
            <OrderCard
              key={order.id}
              id={order.id}
              status={order.status}
              orderDate={order.createdAt}
              sellingOrganizationName={order.sellingOrganization.name}
              itemCount={order.items.length}
              totalAmount={calculateOrderTotal(order)}
              onClick={() => navigate(`/orders/view/${order.id}`)}
            />
          );
        } else {
          return (
            <SellerOrderCard
              key={order.id}
              id={order.id}
              status={order.status}
              orderDate={order.createdAt}
              buyingOrganizationName={order.buyingOrganization.name}
              itemCount={order.items.length}
              totalAmount={calculateOrderTotal(order)}
              onClick={() => navigate(`/orders/view/${order.id}`)}
            />
          );
        }
      })}
    </div>
  );
}
